import { render } from "./AllSubscription.vue?vue&type=template&id=f1b2dfaa"
import script from "./AllSubscription.vue?vue&type=script&lang=js"
export * from "./AllSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/maskansazangolchin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__